var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Navbar'),_c('v-main',{staticClass:"mainContainer"},[_c('v-container',[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('SidebarRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }